import { inject, Injectable } from "@angular/core";
import { GetScenarioProcessHeatMapGQL, GetScenarioProcessHeatMapQuery, GetScenarioRiskHeatMapGQL, GetScenarioRiskHeatMapQuery, GetScenarioLegalEntitiesGQL, GetScenarioLegalEntitiesQuery, GetScenarioLegalEntityHeatMapGQL, GetScenarioLegalEntityHeatMapQuery, GetScenarioHeatmapsGQL, GetScenarioHeatmapsQuery } from "../../../graphql/generated";
import { map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ScenarioConsolidationService {
    private readonly GetScenarioProcessHeatMapGQL: GetScenarioProcessHeatMapGQL = inject(GetScenarioProcessHeatMapGQL);
    private readonly GetScenarioRiskHeatMapGQL: GetScenarioRiskHeatMapGQL = inject(GetScenarioRiskHeatMapGQL);
    private readonly GetScenarioLegalEntityHeatMapGQL: GetScenarioLegalEntityHeatMapGQL = inject(GetScenarioLegalEntityHeatMapGQL);
    private readonly GetScenarioLegalEntitiesGQL: GetScenarioLegalEntitiesGQL = inject(GetScenarioLegalEntitiesGQL);
    private readonly GetScenarioHeatmapsGQL: GetScenarioHeatmapsGQL = inject(GetScenarioHeatmapsGQL);

    getProcessHeatMap(scenarioId: string, valueChain: string[]): Observable<GetScenarioProcessHeatMapQuery['scenarioProcessHeatMaps']> {
        return this.GetScenarioProcessHeatMapGQL.fetch({ scenarioId, valueChain: valueChain }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.scenarioProcessHeatMaps))
    }

    getRiskHeatMap(scenarioId: string): Observable<GetScenarioRiskHeatMapQuery['scenarioRiskHeatMaps']> {
        return this.GetScenarioRiskHeatMapGQL.fetch({ scenarioId }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.scenarioRiskHeatMaps))
    }

    getLegalHeatMap(scenarioId: string, valueChain: string[]): Observable<GetScenarioLegalEntityHeatMapQuery['scenarioLegalEntityHeatMaps']> {
        return this.GetScenarioLegalEntityHeatMapGQL.fetch({ scenarioId, valueChain: valueChain }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.scenarioLegalEntityHeatMaps))
    }


    getScenarioLegalEntities(id: string): Observable<GetScenarioLegalEntitiesQuery['scenarioHistoryById']> {
        return this.GetScenarioLegalEntitiesGQL.fetch({ id }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.scenarioHistoryById))
    }

    getScenarioHeatmaps(scenarioId: string, valueChain: string[]): Observable<GetScenarioHeatmapsQuery['scenarioHeatMaps']> {
        return this.GetScenarioHeatmapsGQL.fetch({ scenarioId, valueChain }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.scenarioHeatMaps))
    }
}